export default "__VITE_ASSET__DzrBTtoT__"